module.exports = __webpack_public_path__ + "img/8.3f778b50.png";